import React from 'react';

import { DragOverlay, useDndContext } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import PropTypes from 'prop-types';

const dropAnimationConfig = {
    keyframes({ transform }) {
        return [{ transform: CSS.Transform.toString(transform.initial) }];
    },
};

export function DraggableOverlay({
    renderer,
    dropAnimation = dropAnimationConfig,
}) {
    const { active } = useDndContext();

    return (
        <DragOverlay dropAnimation={dropAnimation}>
            {active ? renderer({ dragOverlay: true, dragging: true }) : null}
        </DragOverlay>
    );
}

DraggableOverlay.propTypes = {
    renderer: PropTypes.func,
    dropAnimation: PropTypes.object,
};

export default DraggableOverlay;
